module.exports = __webpack_public_path__ + "img/aw-aidt-logo.035b687a.jpg";